import { initAll } from "nhsuk-frontend";

document.addEventListener("DOMContentLoaded", () => {
  // Initialise NHS.UK frontend components
  initAll();
});
